module.exports = __webpack_public_path__ + "img/aura_hit.ef7e2a6e.png";